import type { Product } from '../model/types';
import * as style from './ProductImage.module.css';

interface Props {
    product: Product;
    imageType?: string;
    format?: string;
}

export default function ProductImage({ product, imageType = 'PRIMARY', format = 'product' }: Props) {
    if (!product.images) {
        return <img src="https://bilder.vinmonopolet.no/bottle.png" alt={`Bilde av produktet ${product.name}`} loading="lazy" />;
    }

    const image = product.images?.find((image) => format === image.format && imageType === image.imageType) ?? product.images?.[0];
    return (
        <img
            className={style.productImage}
            src={image?.url}
            srcSet={productImageToSrcSet(image?.url)}
            sizes="auto"
            alt={`Bilde av produktet ${product.name}`}
            loading="lazy"
        />
    );
}

const imageUrlRegex = /^https:\/\/bilder\.vinmonopolet\.no\/cache\/(\d+)x(\d+)-0\/(.+)$/;
export function productImageToSrcSet(url?: string, widths = [150, 300, 600, 900, 1200]) {
    if (!url) return undefined;
    // url has the format https://bilder.vinmonopolet.no/cache/300x300-0/9777201-1.jpg

    const match = url.match(imageUrlRegex);
    if (!match) {
        return undefined;
    }

    const [, widthStr, heightStr] = match;
    const width = parseInt(widthStr, 10);
    const height = parseInt(heightStr, 10);
    return widths.map((w) => `${url.replace(`/cache/${width}x${height}-0/`, `/cache/${w}x${Math.round((height / width) * w)}-0/`)} ${w}w`).join(', ');
}
